<div>
    <h3 style="font-weight: bold; margin: 0;">{{label}}</h3>
    <app-simple-table [pConn$]="pConn$"></app-simple-table>
</div>
